import { OUTCOMES } from "@/lib/content";
import Reveal from "@/components/landing/Reveal";

export default function Promise() {
    return (
        <section
            data-testid="promise-section"
            className="bg-pearl py-32 md:py-44"
        >
            <div className="max-w-[1200px] mx-auto px-6 md:px-12 grid grid-cols-1 lg:grid-cols-12 gap-14 lg:gap-24">
                <div className="lg:col-span-5">
                    <Reveal>
                        <p className="eyebrow text-cacao/60 mb-8">
                            <span className="divider-line text-cacao/40 mr-4 align-middle" />
                            The promise
                        </p>
                    </Reveal>
                    <Reveal delay={120}>
                        <h2
                            data-testid="promise-headline"
                            className="font-serif text-cacao text-[2.4rem] sm:text-[3.2rem] md:text-[4.2rem] leading-[1.02]"
                        >
                            A house that
                            <br />
                            feels like a
                            <span className="italic text-clay-deep"> home.</span>
                        </h2>
                    </Reveal>
                    <Reveal delay={260}>
                        <p className="mt-10 text-cacao/75 text-[1.02rem] leading-[1.85] font-light max-w-[28rem]">
                            We create interiors that are beautiful but livable. Cohesive rather than chaotic. Personal rather than generic. Spaces that hold you — calm, grounding, and quietly alive with the way you actually want to live.
                        </p>
                    </Reveal>
                </div>

                <div className="lg:col-span-7 lg:pl-10">
                    <ul className="divide-y divide-cacao/10" data-testid="promise-list">
                        {OUTCOMES.map((item, i) => (
                            <Reveal
                                key={item}
                                as="li"
                                delay={i * 100}
                                className="py-7 md:py-8 flex items-start gap-6 group"
                            >
                                <span className="font-serif text-clay text-[1.15rem] mt-1 w-10 shrink-0">
                                    0{i + 1}
                                </span>
                                <span className="text-cacao/85 text-[1.05rem] md:text-[1.15rem] leading-[1.55] font-light">
                                    {item}
                                </span>
                            </Reveal>
                        ))}
                    </ul>
                </div>
            </div>
        </section>
    );
}
